import { styled } from '@mui/material/styles';
import React, {useState} from "react";
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Popover from "@mui/material/Popover";

const StatsContainer = styled('div')({
  display: 'flex',
  gap: 6,
  marginBottom: 24,
  alignItems: 'center'
});

const StatsChips = styled('div')({
  display: 'flex',
  gap: 6,
  alignItems: 'center',
  flexWrap: 'wrap'
});

const StatsLabel = styled('div')({
  textTransform: 'capitalize',
  fontSize: 15,
  minWidth: 166
});

const StyledChip = styled(Chip)({
  maxWidth: 360
});

const ChipCountAvatar = styled(Avatar)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: '#fff !important',
  maxWidth: 300
}));

const GuestItem = styled('div')({
  cursor: 'pointer',
  '&:hover': {
    background: '#eee'
  }
});

const GuestStats = ({customerStats, customerIdMap, selectGuest = () => {}}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [customers, setCustomers] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      {customerStats && Object.keys(customerStats).map((tag, index) => (
        <div style={{borderTop:'1px solid #ccc', padding:'16px 0', marginBottom:6}} key={index}>
        <h2 className={'box-head'} style={{color:'#333', marginBottom:'24px'}}>{tag}</h2>
          {customerStats && Object.keys(customerStats[tag]).map(key => (
            <StatsContainer key={key}>
              <StatsLabel>{key}</StatsLabel>
              <StatsChips>
                {customerStats[tag][key].map((items, index) => (
                  <div key={items.label}>
                    <StyledChip
                    variant="outlined"
                    onClick={(e) => {
                    setCustomers(() => {
                      return customerIdMap ? items.customers.map(customerId => customerIdMap[customerId]) : items.customers;
                    });
                    handleClick(e);
                    }}
                    avatar={<ChipCountAvatar>{items.count}</ChipCountAvatar>}
                    title={items.label}
                    label={items.label}
                    key={index}
                    />
                  </div>
                  ))}
              </StatsChips>
            </StatsContainer>
            ))}
        </div>
      ))}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}

        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{padding:6}}>
        {customers.map((customer, index) => (
          <GuestItem key={index}
            onClick={()=> {
            selectGuest(customer);
            console.log('customer', customer);
            }}>
            {customer.firstName && <div>{customer.firstName} {customer.lastName}</div>}
            {!customer.firstName && customer.email && <div>{customer.email}</div>}
          </GuestItem>
        ))}
        </div>
      </Popover>
      {customerStats && Object.keys(customerStats).length === 0 && <p>No guests found.</p>}
    </div>
  );
};

export default GuestStats;
